import {useEffect, useRef, useState} from 'react';
import {privateMediaUrl, fetchPrivateMedia} from './privateMedia';

export const mediaPreviewUrl = (source, variant) => {
    const url = privateMediaUrl(source);
    if (!url || !['thumbnail', 'screen'].includes(variant)) return null;
    const parsed = new URL(url);
    if (!/\/media\/funerals\/[a-f0-9]{24}\/files\/[a-z0-9_-]+$/.test(parsed.pathname)) return null;
    parsed.pathname += `/preview/${variant}`;
    return parsed.href;
};

const waiting = [];
let running = 0;
const abortError = () => Object.assign(new Error('Request cancelled'), {name: 'AbortError'});
const finishTransfer = () => { running--; pump(); };
function pump() {
    while (running < 4 && waiting.length) {
        const job = waiting.shift();
        job.signal.removeEventListener('abort', job.cancel);
        if (job.signal.aborted) { job.reject(abortError()); continue; }
        running++;
        // Hold the slot until the response body, not just the headers, has arrived.
        fetchPrivateMedia(job.source, {signal: job.signal}).then(response => response.blob())
            .then(job.resolve, job.reject).finally(finishTransfer);
    }
}
export const fetchPreviewBlob = (source, signal, priority = false) => new Promise((resolve, reject) => {
    if (signal.aborted) { reject(abortError()); return; }
    const job = {source, signal, resolve, reject};
    job.cancel = () => {
        const index = waiting.indexOf(job);
        if (index >= 0) waiting.splice(index, 1);
        reject(abortError());
    };
    signal.addEventListener('abort', job.cancel, {once: true});
    if (priority) waiting.unshift(job); else waiting.push(job);
    pump();
});

export const useNearViewport = () => {
    const ref = useRef(null);
    const [near, setNear] = useState(false);
    useEffect(() => {
        if (!ref.current) return undefined;
        if (!window.IntersectionObserver) { setNear(true); return undefined; }
        const observer = new IntersectionObserver(entries => {
            if (entries.some(entry => entry.isIntersecting)) { setNear(true); observer.disconnect(); }
        }, {rootMargin: '200px', threshold: 0});
        observer.observe(ref.current);
        return () => observer.disconnect();
    }, []);
    return [ref, near];
};
